import { render } from "./experience.vue?vue&type=template&id=238b2c09&scoped=true&ts=true"
import script from "./experience.vue?vue&type=script&lang=ts"
export * from "./experience.vue?vue&type=script&lang=ts"

import "./experience.vue?vue&type=style&index=0&id=238b2c09&lang=less&scoped=true"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238b2c09"]])

export default __exports__